export const externalRedirect = (to: string): void => {
  window.location.assign(to)
}
